import React, { Component } from 'react';

import './Error.sass';

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      info: null,
    };
  }

  componentDidCatch(error, info) {
    // TODO: send this error and the redux state to a log server
    this.setState({
      error: error,
      info: info,
    });
  }

  dismiss = () => {
    this.setState({
      error: null,
      info: null,
    });
  };

  render() {
    if (this.state.error) {
      return (
        <div className="error-page">
          <div className="jumbotron">
            <i className="error-icon fa fa-4x fa-exclamation-circle" />
            <h1>Application Error</h1>
            <p className="lead">{this.state.error.toString()}</p>
            <p>
              We apologize, but an error has occurred. We have sent the details
              of this error to our team for further review. You can close this
              message and attempt to continue. However, if the error persists,
              you may need to reload the page.
            </p>
            <div className="text-center">
              <button onClick={this.dismiss} className="btn btn-default btn-lg">
                Close Message
              </button>
            </div>
            <details
              style={{
                whiteSpace: 'pre-wrap',
                maxHeight: '200px',
                overflowY: 'auto',
              }}
            >
              <summary>Error Details</summary>
              {this.state.info.componentStack}
            </details>
          </div>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

export default AppErrorBoundary;
